import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.css'
import useFilterStore from '../../../../../Store/filterStore'
import infoIcon from '../../images/circle-info-regular-full.svg' // path relative to Neighborhood folder
import Tooltip from '@material-ui/core/Tooltip'
import { makeStyles } from '@material-ui/core/styles'

const useTooltipStyles = makeStyles({
  tooltip: {
    display: 'inline-block',
    maxWidth: 500,
    width: 'auto',
    fontSize: '13px',
    padding: '8px',
    whiteSpace: 'normal',
    lineHeight: 1.4,
    textAlign: 'left',
    wordBreak: 'break-word'
  }
})

function Neighborhood ({ setLocalFilters, setLocationChanged }) {
  const {
    allFilters: { neighborhood: initialNeighborhood = '' }
  } = useFilterStore()

  const toolTipClasses = useTooltipStyles()
  const [inputValue, setInputValue] = useState(initialNeighborhood)
  const timerRef = useRef(null) // <-- useRef, not state

  // Debounce updating the parent/localFilters
  useEffect(() => {
    // clear any pending timer
    if (timerRef.current) clearTimeout(timerRef.current)

    // set a new timer
    timerRef.current = setTimeout(() => {
      setLocationChanged(true)
      setLocalFilters(prev => ({ ...prev, neighborhood: inputValue }))
    }, 500)

    // cleanup when input changes or component unmounts
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [inputValue, setLocalFilters, setLocationChanged]) // <-- no timerRef/current here

  // Sync if external store value changes
  useEffect(() => {
    setInputValue(initialNeighborhood || '')
  }, [initialNeighborhood])

  const handleChange = e => {
    setInputValue(e.target.value)
  }

  return (
    <div className={styles.inputColumn}>
      <div className={styles.sectionTitleWithIcon}>
        <label className={styles.labelLocation} htmlFor='neighborhood'>
          Neighborhood
        </label>
        <Tooltip
          title='Filter by the neighborhood where the property is located.'
          arrow
          placement='top'
          classes={{ tooltip: toolTipClasses.tooltip }}
        >
          <img
            src={infoIcon}
            alt='Neighborhood info'
            width={14}
            height={14}
            className={styles.infoIcon}
          />
        </Tooltip>
      </div>

      <input
        id='neighborhood'
        className={styles.neighborhoodInput}
        placeholder='Text'
        type='text'
        value={inputValue}
        onChange={handleChange}
        autoComplete='off'
      />
    </div>
  )
}

export default Neighborhood
